/**
 * Signup password rules (aligned with NS-210):
 * - At least 8 characters
 * - At least one uppercase letter, one lowercase letter, and one digit or symbol
 */
export function isValidSignupPassword(password: string): boolean {
  if (password.length < 8) {
    return false
  }

  const hasUpper = /[A-Z]/.test(password)
  const hasLower = /[a-z]/.test(password)
  const hasDigitOrSymbol = /[0-9]/.test(password) || /[^A-Za-z0-9]/.test(password)

  return hasUpper && hasLower && hasDigitOrSymbol
}
